module.exports = __webpack_public_path__ + "7cfe3657abfcb8a53a566b1221ce0485.svg";